import React from 'react'
import { useEffect, useReducerState, useRef, useCallback } from 'sb-hooks'
import useGlobals from 'sb-hooks/useGlobals'
import { MediaContext } from 'sb-hooks/useMedia'
import { isEqual, throttle } from 'lodash'

import { constants, object, number } from 'common/helpers'


const initialDevice = {
  isIOS: false,
  isDesktop: true,
  isMobile: false,
  isTablet: false,
  isTabletPortrait: false,
  isTabletLandscape: false,

  isExceptDesktop: false,
  isExceptMobile: true,
  isTabletLandscapeAndHigher: true,
  isTabletLandscapeAndLower: false,
  isTabletPortraitAndHigher: true,
  isTabletPortraitAndLower: false,
}

const getMediaTypesByWidth = (device) => {
  const width = object.get(window, 'document.documentElement.clientWidth')

  return {
    ...device,
    isDesktop: width > constants.media.tabletLandscapeEnd,
    isMobile: width <= constants.media.mobileEnd,
    isTablet: number.between(width, [ constants.media.tabletPortraitStart, constants.media.tabletLandscapeEnd ], true),
    isTabletPortrait: number.between(width, [ constants.media.tabletPortraitStart, constants.media.tabletPortraitEnd ], true),
    isTabletLandscape: number.between(width, [ constants.media.tabletLandscapeStart, constants.media.tabletLandscapeEnd ], true),

    isExceptDesktop: width <= constants.media.tabletLandscapeEnd,
    isExceptMobile: width > constants.media.mobileEnd,
    isTabletLandscapeAndHigher: width >= constants.media.tabletLandscapeStart,
    isTabletLandscapeAndLower: width <= constants.media.tabletLandscapeEnd,
    isTabletPortraitAndHigher: width >= constants.media.tabletPortraitStart,
    isTabletPortraitAndLower: width <= constants.media.tabletPortraitEnd,
  }
}

const MediaProvider = ({ children }) => {
  const { device = initialDevice } = useGlobals(({ globals }) => globals)

  const [ mediaParams, setMediaParams ] = useReducerState(device)
  const mediaParamsRef = useRef({})

  const handleSetMediaParams = useCallback((newMediaParams) => {
    setMediaParams(newMediaParams)

    if (typeof window.__updateGlobals__ === 'function') {
      window.__updateGlobals__({ device: newMediaParams })
    }
  }, [ setMediaParams ])

  useEffect(() => {
    const handleResize = throttle(() => {
      const newMediaParams = getMediaTypesByWidth(device)

      if (!isEqual(newMediaParams, mediaParamsRef.current)) {
        mediaParamsRef.current = newMediaParams
        handleSetMediaParams(newMediaParams)
      }
    }, 300)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)

      handleResize.flush()
    }
  }, [])

  return (
    <MediaContext.Provider value={mediaParams}>
      {children}
    </MediaContext.Provider>
  )
}

export default MediaProvider
